import { render, staticRenderFns } from "./AccountantHistory.vue?vue&type=template&id=70246eb9&"
import script from "./AccountantHistory.vue?vue&type=script&lang=js&"
export * from "./AccountantHistory.vue?vue&type=script&lang=js&"
import style0 from "./AccountantHistory.vue?vue&type=style&index=0&id=70246eb9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports